import React from "react";
import Noimage from "../../images/aktcorp/search-product-image.jpg";
import "../image-cut.css"
import Searchproductdaynamic from "./Searchproductdaynamic"
import "./Search.css"

function SearchProducts() {
  return (
    <div className="max-w-full py-3">
      <section className="w-full bg-white rounded-lg">
        <div className="max-w-full mx-auto">
          {/* Grid Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 text-black items-center bg-white rounded-lg overflow-hidden shadow-lg">
            
            {/* Left Side - Text Content */}
            <Searchproductdaynamic/>

            {/* Right Side - Image with Zoom Effect */}
            <div className="w-full flex justify-end overflow-hidden rounded-r-lg">
              <img
                src={Noimage}
                alt="Offshore Industry"
                className="w-full max-w-lg md:max-w-xl lg:max-w-full h-auto object-cover transform scale-100 hover:scale-110 transition duration-300 ease-in-out clip-path-right"
              />
            </div>
            
          </div>
        </div>
      </section>
    </div>
  );
}

export default SearchProducts;
